export default __webpack_public_path__ + "static/media/harbolkick-category-luxury.4dfae156.png";